import React,{useState,useEffect,useContext} from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { ToastContainer, toast } from "react-toastify";
import moment from "jalali-moment";
import { AuthContextUser } from "../context/UserContext";

export const Ticket = () => {
  const { currentUser } = useContext(AuthContextUser);
    const [title,setTitle] = useState('')
    const [descs,setDesc] = useState('')
    const [stat,setStat] = useState('')
    const [date,setDate] = useState('')
    const [uid,setUid] = useState('')

    const ticketReg = async() => {
      try{
        if(!title || !descs){
          toast.warning("لطفا تمامی موارد خواسته شده را پر نمائید")
        }else{
         
      await axios.post("https://clinic.salamatpayanew.ir/Register/ticket",{
        title:title,
        descs:descs,
        stat:stat,
        date:moment(new Date(), "YYYY/MM/DD")
        .locale("fa")
        .format("YYYY/MM/DD"),
        cons:uid

      })
      toast.success("عملیات ثبت تیکت با موفقیت انجام شد")
    }
    }catch(e){
      toast.error("خطا در ایجاد تیکت")
    }
  }

  const [cate, setCate] = useState([]);

  useEffect(() => {
    // لیست مشاور ها
    const getAllProductsRFw = async () => {
      const res = await fetch(
        "https://clinic.salamatpayanew.ir/TicketGetAllConsultant/GetListConsultant"
      );
      setCate(await res.clone().json());
    };
    getAllProductsRFw();
  }, []);

  if (currentUser.tel === null) {
    
  } else {
  return (
    <>
  <section class="m-0 content" dir='rtl'>
            <div class="d-flex flex-column justify-content-start align-items-center">
                <div class="card">
                    <img src="../img/dr03.png" class="position-absolute form-img" alt="" />
                    <div class="d-flex flex-column justify-content-start card-title-container">
                        <div class="card-title text-secondary">به کمک نیاز دارید؟</div>
                        <p class="card-subtitle">جهت ارسال تیکت به مشاور فرم زیر را تکمیل نمایید . درصورت دریافت پاسخ در
                            پنل شما اطلاع داده میشود</p>
                    </div>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100 t-24">
                        <div class="custom-form-control form-group position-relative w-25 priority m-0">
                            <select class="form-select form-control pr-16 my-2" aria-label="Default select example" onChange={(e) => setStat(e.target.value)}>
                                <option selected>اولویت</option>
                                <option value="کم">کم</option>
                                <option value="متوسط">متوسط</option>
                                <option value="بالا">بالا</option>
                            </select>
                        </div>
                        <div class="custom-form-control form-group position-relative w-100 ms-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="موضوع تیکت" onChange={(e) => setTitle(e.target.value)}/>
                        </div>

                        <div class="custom-form-control form-group position-relative w-100 ms-md-3">
                        <select
                              id="selce"
                              className="form-control"
                              onChange={(e) => setUid(e.target.value)}
                              name="uId"
                            >
                              <option value={"23e0w"}>انتخاب مشاور</option>
                              {cate.map((item) => {
                                return <option value={item.meli}>{item.name}</option>;
                              })}
                    </select>
                        </div>
                    </div>
                    <div class="form-group position-relative w-100 t-16">
                        <textarea class="form-control-text my-0 p-3" name="" id="" cols="30" rows="10"
                            placeholder="آدرس" onChange={(e) => setDesc(e.target.value)}>

                        </textarea>
                    </div>
                    <button class="custom-btn-primary t-24 form-submit p-16" onClick={ticketReg}>
                        ارسال تیکت
                    </button>
                </div>
            </div>
        </section>

        <ToastContainer
        position="top-center"
        autoClose={20000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

    </>
  )
  }
}
